// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1At0a","errorLogs":"styles_errorLogs__3ZBRT"};